/**
 * `/t/:token` — the page a tasting card's QR code opens (PLAN-SCORESHEETS S4).
 *
 * Short and outside everything else on purpose: this URL is printed under a QR
 * code on a label somebody may end up typing in by hand, and it addresses a
 * *link*, not a batch in anyone's workspace. The root layout renders it without
 * the app shell (see `__root.tsx`), because the person holding the bottle has no
 * workspace, no account, and no reason to wait on IndexedDB before they can say
 * what they thought of the beer.
 *
 * A taster comes here to send a sheet, and there is still no callback into
 * anyone's workspace. The page does lead somewhere, though, and used to say it
 * led nowhere: the brewer can opt the card into a link to the recipe or the
 * blend in the glass, and the frame carries the same strap the other four public
 * pages carry (PLAN-UX-PASS F4). Both open a page a stranger may read, neither
 * asks the taster for anything, and nothing here reaches a workspace.
 */

import { createFileRoute } from '@tanstack/react-router';
import { TastePage } from '@/components/taste/taste-page';

export const Route = createFileRoute('/t/$token')({
  component: TasteRoute,
});

function TasteRoute() {
  const { token } = Route.useParams();
  return <TastePage token={token} />;
}
